import { render } from "./FileInput.vue?vue&type=template&id=40ee17f5"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"
script.render = render

export default script